import React from "react";
import { formatKennitala, validatePhoneNumber, validateEmail } from "../../utils";
import { SvgPenIcon, SvgCheckIcon, SvgArrowIcon } from '../svg'
import UploadSkilagrein from './upload-skilagrein' 
import ManualRegistration from './manual-registration' 
import { requestNewRLKey } from './utils';

class Skilagreinar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            RLkeyRequestSent: false
        }

        this.RLWebKeyClick = this.RLWebKeyClick.bind(this);
    }

    componentDidMount() {

    }

    async RLWebKeyClick() {
        try {
            let response = await requestNewRLKey(this.props.company.company_id);
            if (response.ok) {
                let msg = await response.json(); 
                if (msg && !(msg.Message && msg.Message.error && msg.Message.error.trim().length>0)) {
                    this.setState({RLkeyRequestSent: true});
                } else {
                    alert(
                        "Villa í samskiptum við þjónustu RL hjá Allianz.\n"+
                        (msg.Message ? msg.Message.message+"\n" : '')+
                        "Vinsamlegast reyndu aftur, eða hafðu samband við\n"+
                        "þjónustuborðið okkar.");

                }
            } else {
                console.log(response);
                alert(
                    "Villa í samskiptum við þjónustu Allianz.\n"+
                    "Vinsamlegast reyndu aftur, eða hafðu samband við\n"+
                    "þjónustuborðið okkar.");
            }
        } catch (err) {
            console.log(err);
            alert(
                "Villa í samskiptum við þjónustu Allianz.\n"+
                "Vinsamlegast reyndu aftur, eða hafðu samband við\n"+
                "þjónustuborðið okkar.");
        }
    }

    render() {
        if  (this.props.companyDetails.data && Object.keys(this.props.companyDetails.data).length > 0) {
            return (
                <>
                    <div className="row">
                        <div className="p-0 col-12" id="accordion-skilagreinar">
                            <div className="accordion">
                                <div className="card">
                                    <div className="group-type collapsed card-header" data-toggle="collapse" data-target={"#collapse-fill-skilagreinar"} aria-expanded="false" aria-controls={"#collapse-2"}>
                                        <button className="toggle-button">
                                            <span></span>
                                            Skrá skilagreinar
                                            <span className="arrow-toggle-button">
                                                <SvgArrowIcon />
                                            </span>
                                        </button>
                                    </div>
                                    <div id="collapse-fill-skilagreinar" data-parent={"#accordion-skilagreinar"} className="collapse">
                                        <ManualRegistration company={this.props.company}/>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion">
                                <div className="card">
                                    <div className="group-type collapsed card-header" data-toggle="collapse"  data-target={"#collapse-upload-skilagreinar"} aria-expanded="false" aria-controls={"#collapse-1"}>
                                        <button className="toggle-button">
                                            <span></span>
                                            Hlaða upp skrá með skilagreinum
                                            <span className="arrow-toggle-button">
                                                <SvgArrowIcon />
                                            </span>
                                        </button>
                                    </div>
                                    <div id="collapse-upload-skilagreinar" data-parent={"#accordion-skilagreinar"} className="collapse">
                                        <UploadSkilagrein company={this.props.company} />
                                    </div>

                                </div>
                            </div>

                            <div className="accordion">
                                <div className="card">
                                    <div className="group-type collapsed card-header" data-toggle="collapse"  data-target={"#collapse-new-veflykill"} aria-expanded="false" aria-controls={"#collapse-2"}>
                                        <button className="toggle-button">
                                            <span></span>
                                            Veflykill skilagreina
                                            <span className="arrow-toggle-button">
                                                <SvgArrowIcon />
                                            </span>
                                        </button>
                                    </div>
                                    { this.state.RLkeyRequestSent &&
                                        <div className="msg success-msg">
                                            <h4>Beiðni hefur verið móttekin!</h4>
                                        </div>
                                    }
                                    <div id="collapse-new-veflykill" data-parent={"#accordion-skilagreinar"} className="collapse text-center">
                                        <h4>Óska eftir nýjum veflykli fyrir skilagreinar</h4>
                                        <p>
                                            Ef þú sækir um nýjan veflykil <b>fellur gamli veflykilinn</b> úr gildi og nýr er sendur í heimabanka undir rafræn skjöl.<br/>
                                            Athugið að það getur tekið <b>allt að 20 mín</b> fyrir nýjan veflykil að birtast í heimabanka.
                                        </p>
                                        <p style={{marginTop:"20px", fontWeight:"bold"}}>Smelltu á staðfesta ef þig vantar nýjan veflykil fyrir skilagreinar</p>
                                        <button className="btn btn-primary xs-mt-10" onClick={this.RLWebKeyClick}>Staðfesta</button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return <>Skráning launagreiðanda ekki fullkláruð í kerfum Allianz. Vinsamlegast hafðu samband við þjónustuborð.</>
        }
    }
}


export default Skilagreinar